import './esrioverride.scss';
import './style.scss';

import LogApi from 'api/LogApi';
import { EsriPackages } from 'models/common-map-types';

import aoiLayer from './aoiLayer';
import baseMapJson from './baseMap';
import eventDetailView from './eventDetails';
import eventsView from './eventsLayer';
import globalReset from './globalViewReset';
import legend from './legend';
import proximalCaseLayer from './proximalCaseLayer';

let esriHelper: EsriPackages = null;
let map = null;
let currentZoom = globalReset.GLOBAL_ZOOM_LEVEL;
let popup = null;

function showEventsView(resetToGlobalView = false) {
  if (resetToGlobalView) {
    globalReset.reset();
  }

  eventDetailView.hide();
  eventsView.show();
}

function showEventDetailView(data) {
  eventsView.hide();
  eventDetailView.showAirportPins(data);
}

function hideEventInfo() {
  eventDetailView.hide();
  eventsView.hide();
}

function initPopup() {
  const popupElement = document.createElement('div');
  popupElement.setAttribute('id', 'eventPopup');

  popup = new esriHelper.Popup(
    {
      highlight: false,
      offsetY: -8,
      anchor: 'top',
    },
    popupElement
  );
  popup.resize(280, 400);
  esriHelper.domClass.add(popup.domNode, 'light');
  map.infoWindow = popup;
}

function initMapEvents() {
  //hide the popup if its outside the map's extent
  map.on('pan-end', function (evt) {
    globalReset.check();

    let loopEvt = null;
    function startRepositionLoop() {
      endRepositionLoop();
      loopEvt = setInterval(function () {
        if (map.infoWindow.isShowing) {
          map.infoWindow.reposition();
        } else {
          endRepositionLoop();
        }
      }, 5000);
    }

    function endRepositionLoop() {
      clearInterval(loopEvt);
    }

    // TODO: window.biod.map.gaEvent('PAN_MAP');

    if (map.infoWindow.isShowing) {
      const xMin = map.geographicExtent.xmin;
      const xMax = map.geographicExtent.xmax;
      const x = map.infoWindow.location.x;

      if (xMin > x) {
        const nX = x + 360;
        if (xMax >= nX && xMin <= nX) {
          map.infoWindow.location.x = nX;
          map.infoWindow.reposition();
        }
      } else if (xMax < x) {
        const nX = x - 360;
        if (xMax >= nX && xMin <= nX) {
          map.infoWindow.location.x = nX;
          map.infoWindow.reposition();
        }
      }
    }

    startRepositionLoop();
  });
  map.on('zoom-end', function (e) {
    globalReset.check();

    if (currentZoom < e.level) {
      // window.biod.map.gaEvent('CLICK_ZOOM_IN', null, e.level);
    } else if (currentZoom > e.level) {
      // window.biod.map.gaEvent('CLICK_ZOOM_OUT', null, e.level);
    }
    currentZoom = e.level;
  });
}

function whenEsriReady(callback: (packages: EsriPackages) => void) {
  (window as any).require(
    [
      'esri/layers/FeatureLayer',
      'esri/renderers/ScaleDependentRenderer',
      'esri/renderers/UniqueValueRenderer',
      'esri/geometry/Point',
      'esri/graphic',
      'esri/dijit/Popup',
      'esri/dijit/PopupTemplate',
      'esri/symbols/TextSymbol',
      'esri/layers/LabelClass',
      'esri/Color',
      'esri/symbols/PictureMarkerSymbol',
      'esri/symbols/SimpleFillSymbol',
      'dojo/dom-class',
      'dojo/dom-construct',
      'dojo/on',
      'dojo/_base/array',
      'esri/geometry/Polygon',
      'esri/geometry/Extent',
      'esri/map',
      'esri/layers/VectorTileLayer',
      'dojo/domReady!',
    ],
    function featureLayerPoint(
      FeatureLayer,
      ScaleDependentRenderer,
      UniqueValueRenderer,
      Point,
      Graphic,
      Popup,
      PopupTemplate,
      TextSymbol,
      LabelClass,
      Color,
      PictureMarkerSymbol,
      SimpleFillSymbol,
      domClass,
      domConstruct,
      on,
      array,
      Polygon,
      Extent,
      Map,
      VectorTileLayer
    ) {
      callback({
        FeatureLayer,
        ScaleDependentRenderer,
        UniqueValueRenderer,
        Point,
        Graphic,
        Popup,
        PopupTemplate,
        TextSymbol,
        LabelClass,
        Color,
        PictureMarkerSymbol,
        SimpleFillSymbol,
        domClass,
        domConstruct,
        on,
        array,
        Polygon,
        Extent,
        Map,
        VectorTileLayer,
      });
    }
  );
}

function renderMap(callback?) {
  try {
    whenEsriReady(_esriHelper => {
      esriHelper = _esriHelper;

      map = new esriHelper.Map('map-div', {
        center: [-46.807, 32.553],
        zoom: currentZoom,
        minZoom: globalReset.GLOBAL_ZOOM_LEVEL,
        showLabels: true, //very important that this must be set to true!
      });

      const basemap = new esriHelper.VectorTileLayer(baseMapJson);
      map.addLayers([basemap]);

      initPopup();
      initMapEvents();

      globalReset.init({ map });
      legend.init(true); // default view is global view
      aoiLayer.init({ esriHelper, map });
      eventsView.init({ esriHelper, map, popup });
      eventDetailView.init({ esriHelper, map });
      proximalCaseLayer.init({ esriHelper, map });
      callback && callback();
    });
  } catch (err) {
    const errStack = err.stack || err || 'No stack information available';
    LogApi.sendLog('error', `Failed to initialize map:\n${err?.message}\n${errStack}`);
    callback && callback();
  }
}

export default {
  renderMap,
  updateEventView: eventsView.updateEventView,
  showEventsView,
  showEventDetailView,
  hideEventInfo,
  setExtentToEventDetail: eventDetailView.setExtentToEventDetail,
};
